








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { stTimeEntryApi } from '@/services/st-api';

@Component({
  components: {},
})
export default class DescriptionTextarea extends Vue {
  @Prop() value!: string;
  @Prop() projectId!: number;
  @Prop() entryDate!: string;

  watcher: any;

  previousDescriptions: string[] = [];
  prevDescriptionsOpen: boolean = false;
  selectedPrevDescription: number = 0;

  async mounted() {
    if (this.projectId && this.entryDate) {
      this.previousDescriptions = await stTimeEntryApi.getPreviousDescriptions(this.entryDate!, this.projectId!);
    }

    this.watcher = this.$watch(
      () => {
        return this.projectId + this.entryDate;
      },
      async () => {
        if (this.projectId && this.entryDate) {
          this.close();
          this.previousDescriptions = await stTimeEntryApi.getPreviousDescriptions(this.entryDate!, this.projectId!);
        }
      }
    );
  }

  beforeDestroy() {
    this.watcher();
  }

  get description() {
    return this.value;
  }

  set description(data: string) {
    this.$emit('input', data);
  }

  selectPrevDescription(index: number) {
    this.description = this.filteredPrevDescriptions[index];
    this.prevDescriptionsOpen = false;
  }

  close() {
    setTimeout(() => {
      this.prevDescriptionsOpen = false;
    }, 100);
  }

  clicked(event:any){
    event.preventDefault();
    if(!this.prevDescriptionsOpen && this.filteredPrevDescriptions.length && !this.isExactMatch){
      this.openPrevDescriptions();
    }

    (this.$refs.description as any).focusNative();
  }

  async handleDescriptionKeyDown(event: any) {
    if (event.code == 'Enter' && event.shiftKey) {
      event.preventDefault();
      this.$emit('submit');
    }

    if (event.code == 'Escape') {
      this.prevDescriptionsOpen = false;
    }

    if (event.code == 'Tab' && !this.prevDescriptionsOpen && this.filteredPrevDescriptions.length && !this.isExactMatch) {
      event.preventDefault();
      this.openPrevDescriptions();
    }

    if (event.code == 'Enter' && this.prevDescriptionsOpen) {
      event.preventDefault();

      this.selectPrevDescription(this.selectedPrevDescription);
    }

    if (event.code == 'ArrowDown') {
      if (this.selectedPrevDescription < this.filteredPrevDescriptions.length - 1) {
        this.selectedPrevDescription += 1;
      }
    }

    if (event.code == 'ArrowUp') {
      if (this.selectedPrevDescription > 0) {
        this.selectedPrevDescription -= 1;
      }
    }
  }

  openPrevDescriptions() {
    if (this.filteredPrevDescriptions.length) {
      setTimeout(() => {
        this.selectedPrevDescription = 0;
        this.prevDescriptionsOpen = true;
      }, 100);
    }
  }

  get isExactMatch() {
    return this.filteredPrevDescriptions.length == 1 && this.description == this.filteredPrevDescriptions[0];
  }

  get filteredPrevDescriptions() {
    return this.previousDescriptions.filter((x) => x.toLowerCase().indexOf(this.description?.toLowerCase() ?? '') > -1).slice(0, 5);
  }
}
